import React from "react";
import moment from "moment";


const TVClassCard = ({ session }) => {
    // Session provides: activityName, activityColor, employeeName, employeePhotoUrl, startTime, endTime, lessonPlan

    const objectives = session.lessonPlan?.objectives || [];

    const isUpcoming = moment().isBefore(moment(session.startTime, "HH:mm"));

    return (
        <div 
            className="card shadow-lg mb-0 border-0 rounded-4 overflow-hidden h-100 d-flex flex-column"
            style={{ 
                backgroundColor: "rgba(0, 0, 0, 0.45)", 
                backdropFilter: "blur(12px)", 
                WebkitBackdropFilter: "blur(12px)",
                opacity: isUpcoming ? 0.65 : 1, 
                transition: "all 0.3s ease-in-out" 
            }}
        >
            {/* Top Color Edge */}
            <div 
                className="w-100 py-1" 
                style={{ backgroundColor: session.activityColor || "#556ee6" }}
            ></div>

            <div className="card-body p-4 d-flex flex-column" style={{ flex: 1, minHeight: 0 }}>
                
                {/* Header: TIME and ACTIVITY */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-3 w-100">
                        <div 
                            className="rounded-3 shadow-sm d-flex justify-content-center align-items-center px-3 py-2 fw-bold"
                            style={{ backgroundColor: "#ffffff", color: "#343a40", fontSize: "1.4rem", whiteSpace: "nowrap" }}
                        >
                            <i className="mdi mdi-clock-outline me-2"></i>
                            {session.startTime}
                        </div>
                        <h4 className="mb-0 fw-bold text-white text-truncate" style={{ fontSize: "2rem" }}>{session.activityName}</h4>
                    </div>
                </div>

                {/* INSTRUCTOR */}
                <div className="d-flex align-items-center mb-4">
                    {session.employeePhotoUrl ? (
                        <img 
                            src={session.employeePhotoUrl} 
                            alt={session.employeeName} 
                            className="rounded-circle shadow-sm me-3 border border-2 border-white"
                            style={{ width: "70px", height: "70px", objectFit: "cover" }}
                        />
                    ) : (
                        <div 
                            className="rounded-circle shadow-sm me-3 d-flex align-items-center justify-content-center bg-dark text-white border border-2 border-secondary"
                            style={{ width: "70px", height: "70px", fontSize: "1.8rem", fontWeight: "bold" }}
                        >
                            {session.employeeName ? session.employeeName.charAt(0).toUpperCase() : "?"}
                        </div>
                    )}
                    <div className="overflow-hidden">
                        <span className="text-white-50 text-uppercase fw-semibold" style={{ fontSize: "1rem", letterSpacing: "1px" }}>PROFESSOR</span>
                        <h5 className="mb-0 fw-bold text-white text-truncate" style={{ fontSize: "1.6rem" }}>{session.employeeName || "Não Definido"}</h5>
                    </div>
                </div>

                {/* OBJECTIVES */}
                <div className="d-flex flex-column" style={{ flexShrink: 1, overflowY: "auto", minHeight: 0 }}>
                    <span className="text-white-50 text-uppercase fw-bold d-block mb-3" style={{ fontSize: "1rem", letterSpacing: "1px" }}>OBJETIVOS DA AULA</span>
                    {objectives.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                            {objectives.map((obj, index) => (
                                <div 
                                    key={index}
                                    className="d-flex align-items-start"
                                    style={{ 
                                        color: "#ffffff",
                                        fontSize: "1.5rem", 
                                        fontWeight: "600",
                                        lineHeight: "1.3"
                                    }}
                                >
                                    <i className="mdi mdi-bullseye-arrow me-2" style={{ color: session.activityColor || "#556ee6", fontSize: "1.8rem", marginTop: "-3px" }}></i>
                                    <span>{obj.name}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-white-50 mb-0" style={{ fontStyle: "italic", fontSize: "1.3rem" }}>
                            Prática livre ou metodologia não cadastrada.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TVClassCard;
